// extracted by mini-css-extract-plugin
module.exports = {"container":"boxContentCreator-module--container--3tpcV"};